import { render } from "./ChildDevelopmentChild.vue?vue&type=template&id=3fa19ee9&ts=true"
import script from "./ChildDevelopmentChild.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentChild.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__